import React from "react";
import Layout from "antd/lib/layout/layout";

import { Typography } from "antd";
import { useTranslation } from "react-i18next";
import i18n from "../../services/i18n";

import SignInForm from "./SignInForm";

import "./index.less";
import SEO from "../../containers/helpers/SEO";
import { useContext } from "react";
import { AuthContext } from "../../contexts/auth/AuthContext";
import { Redirect } from "react-router-dom";
import savLogo from "../../assets/sav-logo.png"          // Tog'a #41: SAV logosi — qora fon uchun (yorqin oltin)
import savLogoInk from "../../assets/sav-logo-ink.png"   // och fon uchun (to'q oltin)
const { Title, Text } = Typography;

export default function Auth() {
  const { t } = useTranslation();
  const { authState } = useContext(AuthContext);

  if (authState.isAuthenticated) return <Redirect to="/" />;

  // Dizayn (2026-10-18): ikki ustunli kirish — chapda brend paneli (qora + oltin), o'ngda forma; telefonda bitta ustun
  return (
    <Layout className="auth-page">
      <SEO title={t("auth")} />
      <aside className="auth-brand-pane">
        <div className="auth-brand-head">
          <img src={savLogo} alt="SAV" className="auth-brand-logo" />
        </div>
        <div className="auth-brand-body">
          <h1>{t("zdAuthHeadline", "Весь бизнес — в одной системе")}</h1>
          <p>{t("zdAuthLead", "Склад, продажи, закупки, финансы и партнёры — с понятной аналитикой в реальном времени.")}</p>
          <ul>
            <li>{t("zdAuthPoint1", "Остатки и движение товаров по каждому складу")}</li>
            <li>{t("zdAuthPoint2", "Продажи, долги и платежи под контролем")}</li>
            <li>{t("zdAuthPoint3", "Роли и права для каждого сотрудника")}</li>
          </ul>
        </div>
        <div className="auth-brand-foot">© {new Date().getFullYear()} SAV</div>
      </aside>
      <main className="auth-form-pane">
        <div className="auth-page-inner">
          <div className="auth-mobile-brand">
            <img src={savLogoInk} alt="SAV" className="auth-mobile-logo on-light" />
            <img src={savLogo} alt="SAV" className="auth-mobile-logo on-dark" />
          </div>
          <Title level={2}>{t("welcomeBack")}</Title>
          <Text className="auth-page-subtitle" type="secondary">
            {t("loginToContinue")}
          </Text>
          <div className="custom-card">
            <SignInForm />
          </div>
          {/* tog'a #3563 2-qism: hamkor bo'lish arizasi — login'siz ochiq sahifa; to'liq yuklash (layout yo'lni sessiyadan oldin tekshiradi) */}
          <Text className="auth-partner-link">
            <a href={i18n.language === "uz" ? "/apply?lang=uz" : "/apply"} data-testid="become-partner-link">
              {t("paBecomePartner")}
            </a>
          </Text>
        </div>
      </main>
    </Layout>
  );
}
